<template>
  <div id="dividends_calc">
      <select v-model="selected_stock" class="spacer-little styled-select">
        <option disabled value="">Выберите компанию</option>
        <option v-for="stock in available_stocks" v-bind:value="stock">
          {{ stock.name }}
        </option>
      </select>
    <div class="spacer-little"
         v-if="selected_stock">
       Биржевое обозначение: {{ selected_stock.ticker }}
     </div>
    <div>Введите инвестируемую сумму</div>
    <input v-model.number="invested_amount" type="number" min=0
     class="spacer-little styled-input">
     <div>Дата покупки</div>
    <flat-pickr v-model="buy_date"
                placeholder="Дата покупки"
                input-class="styled-input styled-input-date spacer-little"
                :config="flat_pickr_config">
    </flat-pickr>
    <div v-if="error" class="error">{{ error }}</div>
    <div
      class="btn btn-dividends_calc spacer-little"
      v-on:click="getDividends">Рассчитать дивиденды
    </div>
    <div v-if="fetching_state === 'FETCHING'"
         class="text-center results-dividends_calc">
      <scale-loader :color="spinner_color"
       :loading="fetching_state === 'FETCHING'"></scale-loader>
    </div>
    <div v-else-if="fetching_state == 'READY'">
      <div v-if="available_stock_count === 0">
        <div>К сожалению, данной суммы недостаточно для покупки.</div>
      </div>
      <div v-else>
        <div>На момент покупки стоимость одной акции {{selected_stock.name}} составляла {{old_price}}.
        </div>
        <div class="spacer-little">
          Вы бы смогли купить {{available_stock_count}} акц., общей стоимостью {{stocks_old_price}}.
          Текущая стоимость акций {{stocks_current_price}}.
        </div>
        <div v-if="sum_dividends">
          <div class="spacer-little">
            За этот период вы бы заработали дивидендами <b class="dividends_calc-sum">{{sum_dividends}}</b> рублей.</div>
          <div>
            Даты закрытия реестра:
            <div v-for="dividend in dividends">
              <ul>
                <li>{{ dividend.record_date }}: <p class="dividends_calc-amount">{{ dividend.amount | rtrim }} рублей на 1 акцию</p></li>
              </ul>
            </div>
          </div>  
        </div>
        <div v-else-if="sum_dividends == 0">
          <div>К сожалению, за указанный период компания не выплачивала дивиденды.</div>
        </div>
      </div>
      <div class="spacer-little"></div>
      <a :href="dividends_link">История дивидендных выплат «{{ selected_stock.name }}»</a>
    </div>
  </div>
</template>


<script>
import {format} from 'date-fns';
import flatPickr from 'vue-flatpickr-component';
import { Russian } from "flatpickr/dist/l10n/ru.js"
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

import trimEnd from 'lodash/trimEnd';


function buildDividendsEndpoint(ticker, dateFrom) {
  return `/api/company/dividends/${ticker}/?from=${dateFrom}`;
}
function buildStockEndpoint(ticker, date) {
  return `/api/company/quotes/${ticker}/${date}/`
}
const roundDecimal = v => Math.round(v * 100) / 100;

const now = format(new Date(), 'YYYY-MM-DD');


const FETCHING = 'FETCHING';
// const DONE = 'DONE';
const READY = 'READY';


export default {
  name: "dividends_calc",
  props: ['available_stocks'],
  data: function () {
    return {
      selected_stock: "",
      invested_amount: 0,
      buy_date: now,
      fetching_state: null,
      spinner_color: "#dedad1",
      error: null,
      old_price: null,
      current_price: null,
      dividends: null,
      flat_pickr_config: {
        defaultDate: now,
        minDate: "2015-01-01",
        maxDate: now,
        locale: Russian
        // allowInput: true
      }
    }
  },
  computed: {
    available_stock_count: function () {
      if (!this.old_price || !this.invested_amount) {
        return 0;
      }

      return Math.floor(this.invested_amount / this.old_price);
    },
    sum_dividends: function () {
      if (this.dividends && this.dividends.length) {
        const r = this.dividends.reduce((sum, d) => sum + Number(d.amount), 0);
        return roundDecimal(r * this.available_stock_count);
      }
      return 0;
    },
    stocks_old_price: function () {
      if (this.available_stock_count && this.old_price) {
        return roundDecimal(this.available_stock_count *
                          this.old_price);
      }
      return 0;
    },
    stocks_current_price: function () {
      if (this.available_stock_count && this.current_price) {
        return roundDecimal(this.available_stock_count * this.current_price);;
      }
      return 0; 
    },
    dividends_link: function () {
      if (!this.selected_stock) {
        return null;
      }
      return `/company/${this.selected_stock.ticker}/dividends/`;
    }
  },
  methods: {
    getDividends() {
      var self = this;

      if (!this.selected_stock || !this.buy_date || !this.invested_amount) {
        this.error = 'Не все поля заполнены';
        return;
      }

      this.fetching_state = FETCHING;

      const ticker = this.selected_stock.ticker;
      const buyDate = this.buy_date;

      const stockEndpoint = buildStockEndpoint(ticker, buyDate)
      const dividendEndpoint = buildDividendsEndpoint(ticker, buyDate);

      $.ajax(stockEndpoint)
       .then((resp) => {
          if (resp.error) {
            self.error = resp.error;
            return $.Deferred().reject();
          }
          self.current_price = roundDecimal(resp.current.close);
          self.old_price = roundDecimal(resp.old.close);

          return $.ajax(dividendEndpoint);
        })
       .then((resp) => {
          self.dividends = resp;
          self.fetching_state = READY;
        })
       .fail(() => {
          self.fetching_state = null;
       });
    },
    resetError() {
      this.error = null;
    },
    resetForm() {
      this.fetching_state = null;
      this.old_price = null;
      this.current_price = null;
      this.dividends = null;
    }
  },
  watch: {
    buy_date: function () {
      this.resetError();
      this.resetForm();
    },
    invested_amount: function () {
      this.resetError();
    },
    selected_stock: function () {
      this.resetError();
      this.resetForm();
    }
  },
  components: {
    flatPickr, ScaleLoader
  },
  filters: {
    roundDecimal: roundDecimal,
    rtrim: (v) => trimEnd(v, "0")
  }
}
</script>